export default __webpack_public_path__ + "static/media/vose-logo.0fe9f24a.png";